var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndermaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 180,
    viewBox: "0 0 288 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_7078)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_116_7078)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.96 182.097C66.2721 176.772 86.1745 158.056 108.219 143.636C140.074 122.798 165.791 133.171 180.077 145.956C196.047 160.247 234.87 180.145 260.352 182.017C262.354 182.044 264.37 182.07 266.4 182.097C264.49 182.204 262.467 182.173 260.352 182.017C138.887 180.418 69.1706 180.047 48.96 182.097Z",
    fill: "url(#paint0_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.78 63.4789C214.78 63.4789 208.012 10.519 168.08 48.5948C116.89 97.4025 82.4809 0.396218 44.5068 39.9932C23.7608 61.6248 78.5819 110.003 41.9691 135.463C5.35639 160.923 35.2756 179.984 35.2756 179.984H243.172C243.172 179.984 264.694 181.538 266.323 154.305C267.95 127.072 242.932 126.742 258.459 92.6621C273.986 58.5826 219.659 85.1706 214.78 63.4789Z",
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_116_7078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.726 80.8437C119.726 84.1562 117.048 86.835 113.706 86.835C113.649 86.835 113.159 86.835 109.559 86.835C107.053 86.835 103.049 86.835 96.6542 86.835H93.601C89.5972 86.9214 86.3999 83.7242 86.3999 79.8644C86.3999 75.9758 89.626 72.7497 93.6874 72.9514C97.1727 62.0633 113.13 63.59 114.484 74.8524C117.48 75.2269 119.726 77.7617 119.726 80.8437Z",
    fill: "url(#paint1_linear_116_7078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.706 86.8351C117.019 86.8351 119.726 84.1563 119.726 80.8438C119.726 77.5313 117.019 74.8525 113.706 74.8525C110.394 74.8525 107.686 77.5313 107.686 80.8438C107.686 84.1563 110.394 86.8351 113.706 86.8351Z",
    fill: "url(#paint2_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.884 86.8928C109.789 86.8928 114.599 82.1113 114.599 76.2064C114.599 70.3015 109.789 65.52 103.884 65.52C97.9788 65.52 93.1685 70.3015 93.1685 76.2064C93.1685 82.1113 97.95 86.8928 103.884 86.8928Z",
    fill: "url(#paint3_linear_116_7078)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_116_7078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.726 88.3768C227.726 93.4784 223.601 97.604 218.455 97.604C218.366 97.604 217.612 97.604 212.067 97.604C208.207 97.604 202.041 97.604 192.193 97.604H187.49C181.324 97.7371 176.4 92.8129 176.4 86.8685C176.4 80.8796 181.368 75.9111 187.623 76.2216C192.991 59.4529 217.568 61.8041 219.653 79.1495C224.266 79.7262 227.726 83.63 227.726 88.3768Z",
    fill: "url(#paint4_linear_116_7078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.454 97.6041C223.556 97.6041 227.726 93.4785 227.726 88.3769C227.726 83.2753 223.556 79.1497 218.454 79.1497C213.353 79.1497 209.183 83.2753 209.183 88.3769C209.183 93.4785 213.353 97.6041 218.454 97.6041Z",
    fill: "url(#paint5_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.327 97.6928C212.421 97.6928 219.83 90.3287 219.83 81.2346C219.83 72.1404 212.421 64.7764 203.327 64.7764C194.233 64.7764 186.825 72.1404 186.825 81.2346C186.825 90.3287 194.189 97.6928 203.327 97.6928Z",
    fill: "url(#paint6_linear_116_7078)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M98.6401 182.122C110.277 178.075 129.904 169.854 144.722 158.894C166.134 143.057 168.927 146.224 182.892 154.143C195.997 161.574 224.27 180.629 241.55 182.073C242.627 182.089 243.711 182.106 244.8 182.122C243.769 182.187 242.683 182.168 241.55 182.073C159.4 180.847 112.271 180.559 98.6401 182.122Z",
    fill: "url(#paint7_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7998 182.126C76.4367 178.5 96.0638 171.136 110.882 161.317C132.294 147.13 135.087 149.967 149.051 157.061C162.156 163.718 190.43 180.788 207.71 182.082C208.787 182.096 209.87 182.111 210.96 182.126C209.929 182.184 208.843 182.167 207.71 182.082C125.56 180.984 78.4302 180.725 64.7998 182.126Z",
    fill: "url(#paint8_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.04 182.133C124.677 178.514 150.837 171.182 164.243 159.475C181 144.842 186.12 145.314 200.084 152.395C213.361 159.126 239.679 180.791 256.641 182.098C257.49 182.11 258.343 182.121 259.2 182.133C258.374 182.179 257.52 182.166 256.641 182.098C174.064 180.994 126.709 180.731 113.04 182.133Z",
    fill: "url(#paint9_linear_116_7078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.4 117.229V164.291C176.4 165.469 175.345 166.32 174.065 166.32H100.255C98.9744 166.32 97.9199 165.404 97.9199 164.291V117.229C97.9199 116.116 98.9744 115.2 100.255 115.2H174.065C175.345 115.2 176.4 116.051 176.4 117.229Z",
    fill: "white",
    stroke: "url(#paint10_linear_116_7078)",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4 115.543V123.497C176.4 123.696 175.345 123.84 174.065 123.84H100.255C98.9744 123.84 97.9199 123.685 97.9199 123.497V115.543C97.9199 115.355 98.9744 115.2 100.255 115.2H174.065C175.345 115.2 176.4 115.344 176.4 115.543Z",
    fill: "url(#paint11_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.96,
    cy: 120.24,
    r: 1.44,
    fill: "#9CACCE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.28,
    cy: 120.24,
    r: 1.44,
    fill: "#BDC6DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.6,
    cy: 120.24,
    r: 1.44,
    fill: "#C9D3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.907 143.7C144.795 143.7 145.557 142.939 145.557 142.05C145.557 141.162 144.795 140.4 143.907 140.4C143.018 140.4 142.256 141.162 142.256 142.05C142.256 143.002 142.955 143.7 143.907 143.7Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.986 148.195H140.161C139.463 146.672 137.623 146.101 136.163 146.862C135.592 147.116 135.084 147.624 134.83 148.195H134.005C134.703 146.227 136.988 145.212 138.892 145.974C139.781 146.354 140.606 147.116 140.986 148.195Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.213 143.7C132.101 143.7 132.863 142.939 132.863 142.05C132.863 141.162 132.101 140.4 131.213 140.4C130.324 140.4 129.562 141.162 129.562 142.05C129.626 143.002 130.324 143.7 131.213 143.7Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.014 117.637C146.461 117.637 147.634 116.464 147.634 115.016C147.634 113.569 146.461 112.396 145.014 112.396C143.566 112.396 142.393 113.569 142.393 115.016C142.393 116.464 143.566 117.637 145.014 117.637Z",
    fill: "#9CACCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.014 98.4185L145.014 113.269",
    stroke: "#9CACCE",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.083 176.965H176.103V178.993H201.083V176.965Z",
    fill: "url(#paint12_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.187 171.341H177.934L176.103 176.965H201.018L199.187 171.341Z",
    fill: "url(#paint13_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8 90.7749V98.4261H137.258L144.19 91.4289L208.8 90.7749Z",
    stroke: "url(#paint14_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19 98.426V91.4287L160.212 98.426V91.4287L152.168 98.426V91.4287L144.19 98.426V91.6903V91.4287",
    stroke: "url(#paint15_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.233 98.4259V90.9055",
    stroke: "url(#paint16_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.233 91.4287V98.426L184.212 91.4287",
    stroke: "url(#paint17_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.211 91.4287V98.426",
    stroke: "url(#paint18_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.844 168.071H184.277V83.6468L188.593 79.6577L192.844 83.6468V168.071Z",
    stroke: "url(#paint19_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 84.1047H192.844",
    stroke: "url(#paint20_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 105.685H192.844",
    stroke: "url(#paint21_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 112.616H192.844",
    stroke: "url(#paint22_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 119.483H192.844",
    stroke: "url(#paint23_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 126.415H192.844",
    stroke: "url(#paint24_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 133.347H192.844",
    stroke: "url(#paint25_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 140.279H192.844",
    stroke: "url(#paint26_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 147.145H192.844",
    stroke: "url(#paint27_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 154.077H192.844",
    stroke: "url(#paint28_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.277 161.009H192.844",
    stroke: "url(#paint29_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.533 91.3634L188.593 79.6577L206.707 90.8402",
    stroke: "url(#paint30_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.211 98.4257L192.844 91.0361",
    stroke: "url(#paint31_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 98.6877L184.473 105.423",
    stroke: "url(#paint32_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 84.2354L184.408 90.7748",
    stroke: "url(#paint33_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.971 91.0361L193.17 98.295",
    stroke: "url(#paint34_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.429 98.295L208.734 91.0361",
    stroke: "url(#paint35_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.972 91.3633L168.452 98.0989",
    stroke: "url(#paint36_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.517 105.881L184.473 112.355",
    stroke: "url(#paint37_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.517 112.878L184.473 119.221",
    stroke: "url(#paint38_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 119.745L184.473 126.153",
    stroke: "url(#paint39_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 126.742L184.473 133.085",
    stroke: "url(#paint40_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 133.608L184.473 139.952",
    stroke: "url(#paint41_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 140.475L184.473 146.884",
    stroke: "url(#paint42_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 147.407L184.473 153.815",
    stroke: "url(#paint43_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 154.338L184.473 160.747",
    stroke: "url(#paint44_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 161.336L184.473 167.679",
    stroke: "url(#paint45_linear_116_7078)",
    strokeWidth: 1.08,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.814 168.006H179.373V171.341H197.814V168.006Z",
    fill: "url(#paint46_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5719 152.504H81.0391V181.337H84.5719V152.504Z",
    fill: "url(#paint47_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.644 152.504H106.111V181.337H109.644V152.504Z",
    fill: "url(#paint48_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.088 153.872H77.1641V165.724H114.088V153.872Z",
    fill: "white",
    stroke: "url(#paint49_linear_116_7078)",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0532 153.872L82.1785 165.61H77.7339L81.6087 153.872H86.0532Z",
    fill: "url(#paint50_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0567 153.872L91.1819 165.61H86.7373L90.4981 153.872H95.0567Z",
    fill: "url(#paint51_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06 153.872L100.185 165.61H95.7402L99.501 153.872H104.06Z",
    fill: "url(#paint52_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.063 153.872L109.188 165.61H104.744L108.504 153.872H113.063Z",
    fill: "url(#paint53_linear_116_7078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.677 120.409C226.677 120.409 223.862 119.352 222.456 124.624C221.051 129.897 216.83 128.856 215.775 134.842C214.719 140.828 216.111 146.814 215.072 149.629C214.033 152.443 210.851 157.035 213.313 162.657C215.775 168.28 221.401 171.811 229.138 169.697C236.876 167.583 244.271 168.29 245.313 155.968C246.356 143.646 236.17 146.46 236.523 141.182C236.876 135.903 242.149 134.139 238.282 129.21C234.415 124.281 231.6 125.688 229.841 122.52C228.082 119.352 226.677 120.409 226.677 120.409Z",
    fill: "#B3EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.991 180.356L227.777 124.466H227.588L225.978 180.463L227.991 180.356Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.367 166.226L213.996 157.028L227.117 164.913L226.367 166.226Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.313 148.527L218.122 141.696L227.871 147.551L227.313 148.527Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.871 159.657L240.243 150.46L227.118 158.341L227.871 159.657Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.985 138.374L236.116 132.331L227.494 137.508L227.985 138.374Z",
    fill: "#4D6173"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_116_7078",
    x: 70.5599,
    y: 57.6259,
    width: 65.0067,
    height: 52.9708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_7078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_116_7078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_116_7078",
    x: 160.56,
    y: 56.8964,
    width: 83.0067,
    height: 64.4703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_7078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_116_7078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_7078",
    x1: -114.665,
    y1: 116.4,
    x2: 327.432,
    y2: 360.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_7078",
    x1: 103.063,
    y1: 74.3441,
    x2: 103.052,
    y2: 87.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_7078",
    x1: 107.045,
    y1: 73.5626,
    x2: 112.382,
    y2: 79.3994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_116_7078",
    x1: 92.1651,
    y1: 71.3027,
    x2: 100.576,
    y2: 74.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_116_7078",
    x1: 202.063,
    y1: 78.3666,
    x2: 202.046,
    y2: 97.9601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_116_7078",
    x1: 208.196,
    y1: 77.1631,
    x2: 216.415,
    y2: 86.1524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_116_7078",
    x1: 185.279,
    y1: 73.6823,
    x2: 198.234,
    y2: 78.7517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_116_7078",
    x1: -11.3459,
    y1: 137.068,
    x2: 288.567,
    y2: 299.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_116_7078",
    x1: -45.1862,
    y1: 141.765,
    x2: 238.865,
    y2: 313.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_116_7078",
    x1: 3.05399,
    y1: 137.068,
    x2: 302.966,
    y2: 299.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_116_7078",
    x1: 38.8634,
    y1: 99.6205,
    x2: 239.41,
    y2: 139.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_116_7078",
    x1: 38.8634,
    y1: 112.567,
    x2: 127.354,
    y2: 215.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_116_7078",
    x1: 157.304,
    y1: 176.348,
    x2: 179.977,
    y2: 206.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_116_7078",
    x1: 175.995,
    y1: 171.341,
    x2: 188.279,
    y2: 185.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F84F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_116_7078",
    x1: 83.4227,
    y1: 88.4431,
    x2: 172.732,
    y2: 179.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_116_7078",
    x1: 126.13,
    y1: 89.2962,
    x2: 179.725,
    y2: 109.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_116_7078",
    x1: 199.48,
    y1: 88.6136,
    x2: 202.025,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_116_7078",
    x1: 170.23,
    y1: 89.2962,
    x2: 190.228,
    y2: 91.7818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_116_7078",
    x1: 183.459,
    y1: 89.2962,
    x2: 186.004,
    y2: 89.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_116_7078",
    x1: 177.831,
    y1: 52.7126,
    x2: 199.633,
    y2: 52.9429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_116_7078",
    x1: 177.831,
    y1: 83.8,
    x2: 189.478,
    y2: 94.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_116_7078",
    x1: 177.831,
    y1: 105.38,
    x2: 189.478,
    y2: 116.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_116_7078",
    x1: 177.831,
    y1: 112.312,
    x2: 189.478,
    y2: 123.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_116_7078",
    x1: 177.831,
    y1: 119.178,
    x2: 189.478,
    y2: 130.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_116_7078",
    x1: 177.831,
    y1: 126.11,
    x2: 189.478,
    y2: 136.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_116_7078",
    x1: 177.831,
    y1: 133.042,
    x2: 189.478,
    y2: 143.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_116_7078",
    x1: 177.831,
    y1: 139.974,
    x2: 189.478,
    y2: 150.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_116_7078",
    x1: 177.831,
    y1: 146.84,
    x2: 189.478,
    y2: 157.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_116_7078",
    x1: 177.831,
    y1: 153.772,
    x2: 189.478,
    y2: 164.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_116_7078",
    x1: 177.831,
    y1: 160.704,
    x2: 189.478,
    y2: 171.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_116_7078",
    x1: 108.262,
    y1: 76.0903,
    x2: 220.522,
    y2: 134.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_116_7078",
    x1: 177.716,
    y1: 88.7841,
    x2: 199.337,
    y2: 91.5372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_116_7078",
    x1: 178.371,
    y1: 96.635,
    x2: 198.662,
    y2: 99.2978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_116_7078",
    x1: 178.256,
    y1: 82.2424,
    x2: 198.684,
    y2: 85.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_116_7078",
    x1: 188.053,
    y1: 88.8239,
    x2: 205.185,
    y2: 90.5737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_116_7078",
    x1: 194.18,
    y1: 88.8239,
    x2: 214.995,
    y2: 91.4201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_116_7078",
    x1: 162.793,
    y1: 89.3105,
    x2: 181.655,
    y2: 91.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_116_7078",
    x1: 178.42,
    y1: 103.908,
    x2: 198.525,
    y2: 106.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_116_7078",
    x1: 178.42,
    y1: 110.945,
    x2: 198.51,
    y2: 113.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_116_7078",
    x1: 178.371,
    y1: 117.792,
    x2: 198.626,
    y2: 120.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_116_7078",
    x1: 178.371,
    y1: 124.809,
    x2: 198.618,
    y2: 127.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_116_7078",
    x1: 178.371,
    y1: 131.675,
    x2: 198.618,
    y2: 134.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_116_7078",
    x1: 178.371,
    y1: 138.522,
    x2: 198.626,
    y2: 141.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_116_7078",
    x1: 178.371,
    y1: 145.454,
    x2: 198.626,
    y2: 148.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_116_7078",
    x1: 178.371,
    y1: 152.385,
    x2: 198.626,
    y2: 155.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_116_7078",
    x1: 178.371,
    y1: 159.402,
    x2: 198.618,
    y2: 162.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_116_7078",
    x1: 165.495,
    y1: 166.99,
    x2: 199.925,
    y2: 187.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_116_7078",
    x1: 81.503,
    y1: 153.003,
    x2: 86.7579,
    y2: 153.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_116_7078",
    x1: 106.575,
    y1: 153.003,
    x2: 111.83,
    y2: 153.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_116_7078",
    x1: 49.3784,
    y1: 150.259,
    x2: 133.644,
    y2: 178.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_116_7078",
    x1: 81.8936,
    y1: 153.872,
    x2: 81.8936,
    y2: 165.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_116_7078",
    x1: 90.897,
    y1: 153.872,
    x2: 90.897,
    y2: 165.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_116_7078",
    x1: 99.8999,
    y1: 153.872,
    x2: 99.8999,
    y2: 165.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_116_7078",
    x1: 108.903,
    y1: 153.872,
    x2: 108.903,
    y2: 165.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69603"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_7078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_116_7078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.863,
    height: 149.835,
    fill: "white",
    transform: "translate(23.7598 30.24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndermaintenance);
export default __webpack_public_path__ + "static/media/Under maintenance.45b981fb42f27ae88e95ffd77d50ca9f.svg";
export { ForwardRef as ReactComponent };